import styles from './FJAIVideoGeneratorProgress.module.less';
import CoinBtnBase64 from '../../../../assets/base64/cion-btn.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant.js';
import FJSourceErrorDisplay from '../../../FJMainPreview/FJSourcePreviewItem/FJSourceErrorDisplay.jsx';
import FJUtil from '../../../../util/FJUtil.js';

const JumpDesc = props => {
    const { onClick } = props;

    const decRef = useRef(null);
    useEffect(() => {
        const spanDom = decRef.current?.getElementsByTagName('span')[0];
        if (spanDom) {
            spanDom.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            });
        }
    }, [onClick]);

    return (
        <div
            className={styles.wait_time}
            dangerouslySetInnerHTML={{
                __html: FJLocalStore._(
                    'estimate-wait-time-you-can-still-view-it-in-the-history-after-closing-the-page',
                ),
            }}
            ref={decRef}
        />
    );
};

JumpDesc.propTypes = {
    onClick: PropTypes.func,
};

const FJAIVideoGeneratorProgress = props => {
    const { getCredit, imgUrl, status, reGenerate, jumpHistory, creditNumber, isVideoEffect, model } = props;

    const errorData = useMemo(() => {
        if (status === FJConstant.VIOLATION) {
            return { errorCode: 423, model };
        }
        if (status === FJConstant.ERROR) {
            return { errorCode: 501, model };
        }
        if (status === FJConstant.VIDEO_WITHOUT_PERSON) {
            return { errorCode: 424, model };
        }
        if (status === FJConstant.IMAGE_WITHOUT_PERSON) {
            return { errorCode: 425, model };
        }
        return null;
    }, [status, model]);
    const useVideoSimpleErrorText = useMemo(() => {
        return (
            status === FJConstant.VIDEO_WITHOUT_PERSON ||
            status === FJConstant.IMAGE_WITHOUT_PERSON ||
            isVideoEffect ||
            FJUtil.isVideoGenerator()
        );
    }, [status, isVideoEffect]);
    const isShowRetryBtn = useMemo(() => {
        if (status === FJConstant.VIDEO_WITHOUT_PERSON || status === FJConstant.IMAGE_WITHOUT_PERSON || status === FJConstant.VIOLATION) {
            return false;
        }
        return true;
    }, [status]);
    return (
        <div className={styles.box}>
            <div className={styles.inner}>
                {imgUrl && (
                    <>
                        <img className={styles.bk_img} src={imgUrl} alt='' />
                        <div className={styles.mask} />
                    </>
                )}

                <div className={styles.content}>
                    {(status === FJConstant.RUNNING || status === FJConstant.WAITING) && (
                        <>
                            <div className={styles.title}>
                                {FJLocalStore._(status === FJConstant.WAITING ? 'queuing-dots' : 'generating_')}
                            </div>
                            <div className={styles.progress}>
                                <div className={styles.line} />
                            </div>
                            <JumpDesc onClick={jumpHistory} />
                            {creditNumber < 20 && (
                                <div className={styles.btn} onClick={getCredit}>
                                    <img src={CoinBtnBase64} alt='' />
                                    {FJLocalStore._('get-credits')}
                                </div>
                            )}
                        </>
                    )}
                    {(status === FJConstant.ERROR ||
                        status === FJConstant.VIOLATION ||
                        status === FJConstant.VIDEO_WITHOUT_PERSON ||
                        status === FJConstant.IMAGE_WITHOUT_PERSON) && (
                            <>
                                {errorData && (
                                    <FJSourceErrorDisplay
                                        data={errorData}
                                        isVideoEffect={isVideoEffect}
                                        useVideoSimpleErrorText={useVideoSimpleErrorText}
                                    />
                                )}
                                {isShowRetryBtn && (
                                    <div className={styles.retry_btn} onClick={reGenerate}>
                                        {FJLocalStore._('retry')}
                                    </div>
                                )}
                            </>
                        )}
                </div>
            </div>
        </div>
    );
};

FJAIVideoGeneratorProgress.propTypes = {
    getCredit: PropTypes.func,
    imgUrl: PropTypes.string,
    status: PropTypes.string,
    reGenerate: PropTypes.func,
    jumpHistory: PropTypes.func,
    creditNumber: PropTypes.number,
    isVideoEffect: PropTypes.bool,
    model: PropTypes.string,
    linkUrl: PropTypes.string,
};

export default FJAIVideoGeneratorProgress;
